import { render } from "./DuplicateSessionModal.vue?vue&type=template&id=a671c82c&scoped=true"
import script from "./DuplicateSessionModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DuplicateSessionModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./DuplicateSessionModal.vue?vue&type=style&index=0&id=a671c82c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a671c82c"]])

export default __exports__